import '../ui-anchor/ui-anchor.et';
import '../ui-annotation/ui-annotation.et';
import '../ui-assets/ui-assets.et';
import '../ui-autocomplete/ui-autocomplete.et';
import '../ui-breadcrumbs/ui-breadcrumbs.et';
import '../ui-button/ui-button.et';
import '../ui-calendar/ui-calendar.et';
import '../ui-chip/ui-chip.et';
import '../ui-comparison-cards/ui-comparison-cards.et';
import '../ui-countdown/ui-countdown.et';
import '../ui-curtain/ui-curtain.et';
import '../ui-datepicker/ui-datepicker.et';
import '../ui-daterange/ui-daterange.et';
import '../ui-dialogbubble/ui-dialogbubble.et';
import '../ui-dropdown/ui-dropdown.et';
import '../ui-feedback/ui-feedback.et';
import '../ui-field/ui-field.et';
import '../ui-footer/ui-footer.et';
import '../ui-form/ui-form.et';
import '../ui-message/ui-message.et';
import '../ui-modal/ui-modal.et';
import '../ui-monthpicker/ui-monthpicker.et';
import '../ui-nav/ui-nav.et';
import '../ui-navitem/ui-navitem.et';
import '../ui-navlist/ui-navlist.et';
import '../ui-navtoggle/ui-navtoggle.et';
import '../ui-offer/ui-offer.et';
import '../ui-salesribbon/ui-salesribbon.et';
import '../ui-pagination/ui-pagination.et';
import '../ui-phonefield/ui-phonefield.et';
import '../ui-searchinput/ui-searchinput.et';
import '../ui-signing/ui-signing.et';
import '../ui-skip-to-content/ui-skip-to-content.et';
import '../ui-slider/ui-slider.et';
import '../ui-slides/ui-slides.et';
import '../ui-stepper/ui-stepper.et';
import '../ui-table-cloneable/ui-table-cloneable.et';
import '../ui-table-expandable/ui-table-expandable.et';
import '../ui-table-sortable/ui-table-sortable.et';
import '../ui-tabs/ui-tabs.et';
import '../ui-textcounter/ui-textcounter.et';
import '../ui-timerange/ui-timerange.et';
import '../ui-tooltip/ui-tooltip.et';
import '../ui-upload-item/ui-upload-item.et';
import '../ui-upload/ui-upload.et';
import '../ui-video/ui-video.et';
import '../ui-wizard/ui-wizard.et';
import '../ui-asset/ui-asset.et';
import '../ui-slideview/ui-slideview.et';
import '../ui-rating/ui-rating.et';
import { Labels } from '../../shared-components/global/labels';
import { Language } from '../../shared-components/global/enums';

Labels.LANGUAGE = Language.Estonian;

window.UI = { ...window.UI, Labels };
